import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import rightCheck from "../assets/icons/right-check.svg";
import { getIn } from "formik";

const SearchableSelectInput = ({ field, formik }) => {
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      height: "44px",
      borderRadius: "8px",
      boxShadow: state.isFocused ? "0px 1px 2px 0px rgba(16, 24, 40, 0.05)" : "none",
      borderColor: state.isFocused ? "#4A90E2" : "#b9b9ba",
      "&:hover": {
        borderColor: "#4A90E2",
      },
      backgroundColor: field?.readonly || field?.isDisableField ? "#f9fafb" : "inherit",
      cursor: field?.readonly || field?.isDisableField ? "not-allowed" : "pointer",
      pointerEvents: field?.readonly || field?.isDisableField ? "none" : "auto",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#667085",
      opacity: field?.isDisableField ? 0.7 : 1,
      fontSize: "14px",
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "8px",
      boxShadow: "0px 4px 6px rgba(16, 24, 40, 0.1)",
      zIndex: 999999,
      overflowY: "auto",
      position: "absolute",
      scrollbarWidth: "none", // Firefox
      "&::-webkit-scrollbar": {
        display: "none", // Chrome, Safari, Edge
      },
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: 230,       
      overflowY: "auto",
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 999999,
    }),
    option: (provided, state) => {
      let backgroundColor = "white";

      if (state.isSelected) {
        backgroundColor = "#d3d3d3";
      } else if (state.isFocused) {
        backgroundColor = "#f0f0f0";
      }

      return {
        ...provided,
        fontSize: "14px",
        backgroundColor,
        color: "#1c252e",
        "&:hover": {
          backgroundColor: "#f0f0f0",
        },
      };
    },
    singleValue: (provided) => ({
      ...provided,
      color: "#1c252e",
      fontSize: "14px",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      cursor: field?.readonly || field?.isDisableField ? "not-allowed" : "pointer",
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      cursor: field?.readonly || field?.isDisableField ? "not-allowed" : "pointer",
    }),
  };

  const handleChange = (selectedOption) => {
    const event = {
      target: {
        name: field?.name,
        value: selectedOption?.value,
      },
    };
    field?.handleOnChange
      ? field?.handleOnChange(event, field?.index, field?.name, null)
      : formik?.handleChange(event);
  };

  const options = field?.options?.map((option) => ({
    value: option.value,
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        {option.name}
        {field.showIcon && formik?.values?.[field?.name] === option.value && (
          <img
            src={rightCheck}
            alt="Selected"
            style={{ marginLeft: "auto", width: "16px", height: "16px" }}
          />
        )}
      </div>
    ),
    name: option.name, 
  }));

  const filterOption = (candidate, input) => {
    const inputLower = input.toLowerCase();
    return candidate.data.name.toLowerCase().includes(inputLower);
  };

  return (
    <div style={{ cursor: field?.readonly || field?.isDisableField ? "not-allowed" : "auto" }}>
      {field?.label && (
        <label
          htmlFor={field?.name}
          style={{
            color: "#1c252e",
            fontSize: "14px",
            fontWeight: "500",
            lineHeight: "22px",
            marginBottom: "6px",
            display: "block",
          }}
        >
          {field?.label}
          {field?.required && <span style={{ color: "#d3151a" }}> *</span>}
        </label>
      )}
      <Select
        id={field?.name}
        name={field?.name}
        styles={customStyles}
        placeholder={field?.placeholder}
        options={options}
        value={
          options?.find(
            (option) => option.value === getIn(formik.values, field?.name)
          ) || null
        }
        onChange={handleChange}
        onBlur={() => formik.setFieldTouched(field?.name, true, true)}
        isDisabled={field?.readonly || field?.isDisableField}
        isSearchable
        noOptionsMessage={() => "No options available"}
        filterOption={filterOption}
        menuPlacement="auto"
        menuPosition="fixed" 
        menuPortalTarget={document.body}
      />
      {formik?.touched?.[field?.name] && formik?.errors?.[field?.name] && (
        <span style={{ color: "#d3151a", fontSize: "12px" }}>
          {formik.errors[field?.name]}
        </span>
      )}
    </div>
  );
};



SearchableSelectInput.propTypes = {
  field: PropTypes.any,
  formik: PropTypes.object,
};

export default SearchableSelectInput;
